import { ONE_HOUR_MS } from 'shared'

export function toTimeISOString(date: Date) {
  const timezoneOffset = date.getTimezoneOffset()

  return new Date(date.getTime() - timezoneOffset * ONE_HOUR_MS)
    .toISOString()
    .slice(11, 16)
}

export function toDateISOString(date: Date) {
  const timezoneOffset = date.getTimezoneOffset()

  return new Date(date.getTime() - timezoneOffset * ONE_HOUR_MS)
    .toISOString()
    .slice(0, 10)
}
